import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_HEADER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: `calc(100vh - ${HEIGHT_HEADER}px)`,
				overflowY: "scroll",
				overflowX: "hidden"
			},
			bannerYellow: {
				background: `linear-gradient(180deg, ${theme.palette.primary.main} 40%,${theme.palette.primary.main} 75%, ${theme.palette.primary.main}20 85%, #fff 90%, #fff 100%)`,
				backdropFilter: "blur(7.5px)",
				padding: "0px 16px"
			},
			btnDefault: {
				textAlign: "center",
				marginTop: 16,
				width: "100%",
				border: "none",
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				borderRadius: 6,
				padding: 16,
				fontSize: 14
			}
		}),
	{
		name: "AccumulationProgramDetailPage",
		index: 1
	}
);

export default useStyles;
